/**
 * The PasswordReset Form component
 */
import { get } from 'lodash';
import React, { useCallback, useState } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { decode } from 'querystring';

import { LoginLayout } from '../Login/LoginLayout.tsx';
import { EmailForm } from './EmailForm.tsx';
import { PasswordForm } from './PasswordForm.tsx';

export default function PasswordReset(props) {
  const {
    isLoggedIn,
    influencer = false,
    resetPassword,
    updatePassword,
    location,
  } = props;
  const token = get(decode(location.search.slice(1)), 'token');

  const [errorTitle, setErrorTitle] = useState(undefined);
  const [errorDescription, setErrorDescription] = useState(undefined);
  const handleError = useCallback((title, subTitle) => {
    setErrorTitle(title || undefined);
    setErrorDescription(subTitle || undefined);
  }, []);

  if (isLoggedIn) {
    return (
      <Redirect
        to={{
          pathname: '/',
          state: { from: location },
        }}
      />
    );
  }

  return (
    <LoginLayout
      isInfluencer={influencer}
      errorTitle={errorTitle}
      errorDescription={errorDescription}
    >
      {!token ? (
        <EmailForm
          isInfluencer={influencer}
          resetPassword={resetPassword}
          onError={handleError}
        />
      ) : (
        <PasswordForm
          isInfluencer={influencer}
          token={token}
          updatePassword={updatePassword}
          onError={handleError}
        />
      )}
    </LoginLayout>
  );
}

PasswordReset.propTypes = {
  resetPassword: PropTypes.func.isRequired,
  updatePassword: PropTypes.func.isRequired,
  influencer: PropTypes.bool,
  isLoggedIn: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    key: PropTypes.string,
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
    state: PropTypes.shape({}),
  }).isRequired,
};
